import React from 'react'

import { extendCopyContentWithComplianceMessage, writeCopyContentToClipboard } from '../../../../../../../common/copy'
import { useEffectiveConfig } from '../../../../../../../common/useEffectiveConfig'

import { Button } from '../../../../../../../components/Button/Button'

import { showToast } from '../../../../../../../store/meetingSummary/display'
import { useAppDispatch } from '../../../../../../../store/hooks'

import { TrackEvent, useTracking } from '../../../../common/tracking'

import { useMeetingSummaryElementsCopy } from './hooks'

export const MeetingSummaryAgentCopyButton: React.FC = () => {
  const dispatch = useAppDispatch()

  const { tracked } = useTracking()
  const { getCopyContent } = useMeetingSummaryElementsCopy()
  const { copyComplianceMessage, accountIsFetching } = useEffectiveConfig()

  const _handleCopy = async () => {
    const copyContent = extendCopyContentWithComplianceMessage(getCopyContent(), copyComplianceMessage)

    await writeCopyContentToClipboard(copyContent)

    dispatch(showToast({ variant: 'success', icon: 'bi-check-circle-fill', message: 'Copied to clipboard!' }))
  }

  const handleCopy = tracked(_handleCopy, { eventName: TrackEvent.MEETING_SUMMARY_AGENT_RESULT_COPIED })

  return (
    <Button className='px-2 py-1 button-medium' variant='header' onClick={handleCopy} disabled={accountIsFetching}>
      <i className='bi bi-copy' />
      Copy
    </Button>
  )
}
